import { debounce } from 'lodash';
import { useEffect, useMemo, useRef } from 'react';

type Noop = (...args: any[]) => any;

interface DebounceOptions {
    wait?: number;
    leading?: boolean;
    trailing?: boolean;
    maxWait?: number;
}

// https://ahooks.js.org/hooks/use-debounce-fn
function useDebounceFn<T extends Noop>(fn: T, options?: DebounceOptions) {
    const fnRef = useRef(fn);

    fnRef.current = fn;

    const wait = options?.wait ?? 1000;

    const debounced = useMemo(
        () =>
            debounce(
                (...args: Parameters<T>): ReturnType<T> => {
                    return fnRef.current(...args);
                },
                wait,
                options
            ),
        // 不需要依赖
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    useEffect(() => {
        return () => {
            debounced.cancel();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        run: debounced,
        cancel: debounced.cancel,
        flush: debounced.flush
    };
}

export default useDebounceFn;
